import PermissionsContext from './PermissionsContext.js';
import { useRef } from 'react';
import { searchPermittedActions } from '../../../apis/resource-manager-api.js';
import SpnPermission from './SpnPermission.js';

const ALL_ACTIONS = Object.values(SpnPermission);

export default function PermissionsProvider({ children }) {
  const permissionsCache = useRef(null);

  const checkPermissionWithCache = async (actionKey) => {
    let permittedActionsPromise = permissionsCache.current;

    if (!permittedActionsPromise) {
      permittedActionsPromise = searchPermittedActions(ALL_ACTIONS);
      permittedActionsPromise.catch((err) => {
        console.error('Permission check failed.', err);
        permissionsCache.current = null;
      });

      permissionsCache.current = permittedActionsPromise;
    }

    const permittedActions = await permittedActionsPromise;
    return permittedActions.includes(actionKey);
  };

  const checkComplexPermissions = async (permissions) => {
    if (typeof permissions === 'string') {
      return checkPermissionWithCache(permissions);
    } else {
      const promises = [];
      if (permissions.allOf) {
        promises.push(
          Promise.all(permissions.allOf.map((permission) => checkComplexPermissions(permission))).then((results) =>
            results.every(Boolean)
          )
        );
      }
      if (permissions.oneOf) {
        promises.push(
          Promise.all(permissions.oneOf.map((permission) => checkComplexPermissions(permission))).then((results) =>
            results.some(Boolean)
          )
        );
      }
      if (permissions.not) {
        promises.push(checkComplexPermissions(permissions.not).then((result) => !result));
      }

      return (await Promise.all(promises)).every(Boolean);
    }
  };

  return (
    <PermissionsContext.Provider
      value={{
        flushPermissions: () => (permissionsCache.current = null),
        checkPermissions: checkComplexPermissions
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
}
